import Passengers from './Passengers';
export default Passengers;
